import React, { Component } from 'react'
import { Link }             from 'react-router-dom'

import { formatHTML } from './components/format'

import './css/first-page.css'

export default class FirstPage extends Component {

  render() {
    return (
      <div className="first-page">
        <div className="first-page-title" dangerouslySetInnerHTML={{__html: formatHTML(this.props.data.content.first_page_title)}} />
        {this.props.data.first_page.map((item, n) => (
          <Link
            key         = {n}
            to          = {this.props.data.parseURL(item.url)}
            style       = {{backgroundImage: `url(${item.image})`}}
            className   = "first-page-item"
          >
            <div className ="first-page-item-shadow">
              <div className="first-page-item-text">{item.text}</div>
            </div>
          </Link>
        ))}
        <div className="first-page-epilog" dangerouslySetInnerHTML={{__html: formatHTML(this.props.data.content.first_page_epilog)}} />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/first-page.js